/*
 * @Author: libo 
 * @Date: 2020-11-18 21:11:26 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-06-21 11:55:07
 */

<!--换表界面-->
<template>
  <a-spin :spinning="confirmLoading">
    <div class="form-contain">
      <a-divider orientation="left">{{ $t('用户信息') }}</a-divider>
        <detail-list>
          <detail-list-item :term="$t('用户编号')">{{model.userId}}</detail-list-item>
          <detail-list-item :term="$t('用户姓名')">{{model.userName}}</detail-list-item>
          <detail-list-item :term="$t('手机号码')">{{model.userPhone}}</detail-list-item>
          <detail-list-item :term="$t('身份证号')">{{model.userIdNumber}}</detail-list-item>
          <!-- <detail-list-item term="价格编码">{{model.userPriceCode}}</detail-list-item> -->
          <!-- <detail-list-item term="价格名称">{{model.wtName}}</detail-list-item> -->
          <!-- <detail-list-item term="价格总计">{{model.wtTotalPrice}}</detail-list-item> -->
          <detail-list-item :term="$t('用水状态')">{{model.userState==0?$t('未开始计费'):model.userState==1?$t('已开始计费'):''}}</detail-list-item>
          <!-- <detail-list-item term="区域名称">{{model.userAreaName}}</detail-list-item> -->
          <detail-list-item :term="$t('类型名称')">{{model.userTypeName}}</detail-list-item>
          <detail-list-item :term="$t('价格名称')">{{model.wtName}}</detail-list-item>
          <detail-list-item :term="$t('用户地址')" style="width: 66.66%;">{{model.userAreaName.slice(model.userAreaName.indexOf('-')+1,model.userAreaName.length)+'-'+model.userAddr}}</detail-list-item>
        </detail-list>
        <a-divider orientation="left">{{ $t('旧表具信息') }}</a-divider>
        <detail-list>
          <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
          <!-- <detail-list-item term="安装经度">{{model.userMeterLng}}</detail-list-item> -->
          <!-- <detail-list-item term="安装维度">{{model.userMeterLat}}</detail-list-item> -->
          <!-- <detail-list-item term="阀门状态">{{model.userValveOpenorclose==0?"无动作":model.userValveOpenorclose==1?"开阀":model.userValveOpenorclose==2?"关阀":''}}</detail-list-item> -->
          <detail-list-item :term="$t('表计费起始读数(m³)')">{{model.userMeterStartNum}}</detail-list-item>
          <!-- <detail-list-item term="开户时读数">{{model.userMeterOpenNum}}</detail-list-item> -->
          <detail-list-item :term="$t('表安装地址')">{{model.userAddr}}</detail-list-item>
          <detail-list-item :term="$t('末次上报读数(m³)')">{{MeterUserInfoByKey.meterTotalUse}}</detail-list-item>
          <detail-list-item :term="$t('末次上报日期')">{{MeterUserInfoByKey.meterUpTime}}</detail-list-item>
          <!-- <detail-list-item term="当前表读数">{{model.userMeterStartNum}}</detail-list-item> -->
          <detail-list-item :term="$t('末次上报结算余额(元)')">{{MeterUserInfoByKey.userAccountNum}}</detail-list-item>
          <detail-list-item :term="$t('末次上报结算流量(m³)')">{{MeterUserInfoByKey.userCalNum}}</detail-list-item>
        </detail-list>
        <a-form :form="form" ref="form" slot="detail" :colon="false" layout="vertical">
          <a-divider orientation="left">{{ $t('新表具信息') }}</a-divider>
          <a-row :gutter="16">
            <a-col :span="8">
              <a-form-item :label="$t('新表编号')">
                <a-input  v-decorator="['meterIdNew',validatorRules.meterIdNew]" :placeholder="$t('新表编号')" :readOnly="true" @click="setModalVisible()" style="width:100%"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('新表表端累计读数(m³)')">
                <a-input v-decorator="['meterTotalUse',validatorRules.meterTotalUse]" disabled></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('上报时间')">
                <a-input v-decorator="['sysTime',validatorRules.sysTime]" disabled></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('新表开始计费读数(m³)')">
                <a-input-number v-decorator="['meterStartNum',validatorRules.meterStartNum]" :placeholder="$t('新表开始计费读数')" style="width:100%" :disabled="startDisabled"></a-input-number>
              </a-form-item>
            </a-col>
            <!-- <a-col :span="8">
              <a-form-item label="厂商代码">
                <a-input v-decorator="['mtComCode']" placeholder="请输入厂商代码" />
              </a-form-item>
            </a-col> -->
            <!-- <a-col :span="8">
              <a-form-item label="新表开始计费读数">
                <a-input v-decorator="['firstValue',validatorRules.firstValue]" placeholder="请输入启用表底数" />
              </a-form-item>
            </a-col> -->
          </a-row>
        <a-divider orientation="left">{{ $t('换表操作') }}</a-divider>
        <a-row :gutter="16">
          <a-col :span="8">
            <a-form-item :label="$t('旧表机械读数(m³)')">
              <a-input  v-decorator="['meterOldMachineSumFlow',validatorRules.meterOldMachineSumFlow]" :placeholder="$t('请输入旧表机械读数')" style="width:100%" @change="meterOldMachineSumFlowChange"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('换表原因')">
              <a-cascader
                v-decorator="['meterChangeType',validatorRules.meterChangeType]"
                :options="options"
                expand-trigger="hover"
                :placeholder="$t('请选择换表原因')"
                changeOnSelect
                @change="onChange"
              />
              <!-- <a-select v-decorator="['meterChangeType',validatorRules.meterChangeType]" placeholder="请选择换表原因" style="width:100%" :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
                <a-select-option :value="1">
                  流量异常
                </a-select-option>
                <a-select-option :value="2">
                  机械故障
                </a-select-option>
                <a-select-option :value="3">
                  其他
                </a-select-option>
              </a-select> -->
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('换表结算余额(元)')">
              <a-input v-decorator="['meterUserAccountNumAfterChange',validatorRules.meterUserAccountNumAfterChange]" :suffix="$t('元')" :placeholder="$t('换表后实时金额')" style="width:100%" :disabled="isOldTable"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('是否以旧表机械读数结算')">
              <a-radio-group v-decorator="['whetherSettlementOldTable',validatorRules.whetherSettlementOldTable]" :placeholder="$t('请选择是否以旧表机械读数结算')" :default-value="1" @change="onRadioChnage">
                  <a-radio :value="1">{{ $t('是') }}</a-radio>
                  <a-radio :value="0">{{ $t('否') }}</a-radio>
                </a-radio-group>
            </a-form-item>
          </a-col>
          <!--
          <a-col :span="8">
              <a-form-item label="旧表终止机械读数(m³)">
                <a-input v-decorator="['meterOldSumFlowAfterChange',validatorRules.meterOldSumFlowAfterChange]" suffix="m³" placeholder="换表时旧表终止机械读数" style="width:100%"></a-input>
              </a-form-item>
            </a-col>
          -->
          <a-col :span="24">
            <a-form-item :label="$t('换表原因描述')" >
              <a-textarea v-decorator="['meterChangeReason']" :placeholder="$t('请输入换表原因描述')" :rows="3"></a-textarea>
            </a-form-item>
          </a-col>
        </a-row>
        
      </a-form>
      <a-modal v-model="modal1Visible" :title="title1" centered :width="width">
        <template slot="footer">
          <a-button key="close" @click="handleCancel">
            {{ $t('关闭') }}
          </a-button>
        </template>
        <div class="form-contain">
          <div class="table-page-search-wrapper">
            <a-form layout="inline" @keyup.enter.native="searchQuery">
              <a-row :gutter="24">
                <a-col :xl="12" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('表编号')">
                    <j-input :placeholder="$t('输入表编号模糊查询')" v-model="queryParam.meterId"></j-input>
                  </a-form-item>
                </a-col>
                <a-col :xl="8" :lg="7" :md="8" :sm="24">
                  <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                    <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                    <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <a-table 
            :columns="columns"
            :data-source="meteridlist"
            rowKey='id'
            size="middle"
            :pagination="ipagination"
            @change="handleTableChange"
            class="j-table-force-nowrap"
            >
            <span slot="action" slot-scope="text, record">
              <a-button type="primary" @click="handleEdit(record)">{{ $t('选择') }}</a-button>
            </span>
          </a-table>
        </div>
      </a-modal>
    </div>
  </a-spin>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import { listSize,filterObj } from '@/utils/util'
  import { duplicateCheck } from '@/api/api'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JInput from '@/components/jeecg/JInput'
  import DetailList from '@/components/tools/DetailList'
  import pick from 'lodash.pick'
  const DetailListItem = DetailList.Item
  import {isUndefinedAndNull} from '@/utils/validate'

  export default {
    name: 'MeterTableOfStringsForm',
    mixins:[JeecgListMixin],
    components: {
      DetailList,
      DetailListItem,
      JInput
    },
    data () {
      return {
        activeKey:[1,2],
        genreList: [
          {key: 1, title: this.$t('流量异常')},
          {key: 2, title: this.$t('机械故障')},
          {key: 3, title: this.$t('其他')},
        ],
        form: this.$form.createForm(this),
        model: {},
        confirmLoading: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        ipagination:{
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " " + this.$t('共{total}条', { total: total })
          },
          total: 0
        },
        userHouseholdCodeList:[], // 用户户型
        userPriceCode:[], // 价格编码
        // userTypeList:[],  //表类型
        // userCaliberList:[],  // 表口径
        genreList,
        meterChangeType:'',
        modal1Visible:false,
        width:800,
        meteridlist:[], //表编号
        MeterUserInfoByKey:{},
        url: {
          add:"/jeecg-charge/meter/meterUserinfo/add",
          edit:"/jeecg-charge/meter/meteChangeMeterRecord/doChangeMeterTask",
          queryById:"/jeecg-charge/meter/meterUserinfo/queryById",
          userHouseholdCodeList:"/jeecg-charge/meter/meterHousehold/list",
          // userTypeList:"/meter/meterType/list",  //表类型
          // userCaliberList:"/meter/meterCaliber/list",  //表口径请求地址
          userPriceCode:"/jeecg-charge/meter/meterPriceinfo/list",
          list:"/jeecg-charge/meter/meterinfo/list",
          getMeterUserInfoByKeyId:"/jeecg-charge/meter/meteChangeMeterRecord/getMeterUserInfoByKeyId" ,//换表请求
          useOldMachineSumFlow: "/jeecg-charge/meter/meteChangeMeterRecord/useOldMachineSumFlow",//是否以旧表读数结算
        },
        isOldTable:false,
        startDisabled: false,
      }
    },
    computed: {
      // i18n：列标题/校验消息/级联选项使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId',
          },{
            title: this.$t('表类型'),
            align:"center",
            dataIndex: 'mtCodeName',
          },{
            title: this.$t('表口径'),
            align:"center",
            dataIndex: 'mtCaliber',
            customRender: (text,row) => {
              return 'DN'+text;
            }
          },{
            title: this.$t('水表厂商'),
            align:"center",
            dataIndex: 'mtComName',
          },{
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:90,
            scopedSlots: { customRender: 'action' }
          }
        ];
      },
      title1() {
        return this.$t('请选择表编号')
      },
      options() {
        return [
          {
            value: '0',
            label: this.$t('周期性换表'),
          },
          {
            value: '1',
            label: this.$t('故障换表'),
            children: [
              {
                value: '2',
                label: this.$t('基表问题'),
                children: [
                  {
                    value: '3',
                    label: this.$t('计量问题'),
                  },
                  {
                    value: '4',
                    label: this.$t('阀门故障'),
                  },
                  {
                    value: '5',
                    label: this.$t('基表爆裂'),
                  },
                ],
              },
              {
                value: '6',
                label: this.$t('电子问题'),
                children: [
                  {
                    value: '7',
                    label: this.$t('不上传数据'),
                  },
                  {
                    value: '8',
                    label: this.$t('水表无反应（黑屏，无法激活）'),
                  },
                ],
              },
              {
                value: '9',
                label: this.$t('磁干扰'),
              },
              {
                value: '10',
                label: this.$t('缺电'),
              },
              {
                value: '11',
                label: this.$t('其他'),
              },
            ],
          },
        ];
      },
      // i18n：校验消息使用 computed 以响应语言切换
      validatorRules() {
        return {
          meterOldMachineSumFlow:{
            rules:[
              {required:true,message:this.$t('请输入旧表机械读数！')},
            ]
          },
          whetherSettlementOldTable:{
            rules:[
              {required:true,message:this.$t('请选择是否以旧表机械读数结算！')},
            ]
          },
          userMeterStartNum:{  //表计费起始读数
            rules:[
              {required:true,message:this.$t('请输入表计费起始读数！')},
            ]
          },
          meterChangeType:{
            rules:[
              {required:true,message:this.$t('请选择换表原因类型')}
            ]
          },
          meterIdNew:{
            rules:[
              {required:true,message:this.$t('请选择新表编号')}
            ]
          },
          mtCode:{
            rules:[
              {required:true,message:this.$t('请选择表类型')}
            ]
          },
          mtCaliber:{
            rules:[
              {required:true,message:this.$t('请选择新表口径')}
            ]
          },
          meterStartNum:{
            rules:[
              {required: true, message: this.$t('请输入新表开始计费读数!')},
              {pattern: /^(([0-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,message: this.$t('新表开始计费读数最多保留两位小数')}
            ]
          },
          meterUserAccountNumAfterChange:{
            rules:[
              {required:true,message:this.$t('请输入换表后实时金额')},
              {pattern:/^(-)?(([0-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,message:this.$t('请输入正确的换表后实时金额')}
            ]
          },
          /*
          meterOldSumFlowAfterChange:{
            rules:[
              {required:true,message:'请输入旧表终止机械读数'},
              {pattern:/^(([0-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,message:'请输入正确的换表时旧表终止机械读数'}
            ]
          }
          */
        }
      },
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      },
      title () {
        return this.$route.meta.title
      }
    },
    created() {  //入口
      // this.queryUserTypeList()
      // this.queryUserCaliberList()
    },
    methods: {
      setModalVisible(){
        // this.querymeteridList();
        this.loadData(1);
        this.modal1Visible = true; 
      },
      handleTableChange(pagination, filters, sorter) {
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
        this.ipagination = pagination;
        this.loadData();
      },
      getQueryParams() {
      //获取查询条件
      let sqp = {}
      if(this.superQueryParams){
        sqp['superQueryParams']=encodeURI(this.superQueryParams)
        sqp['superQueryMatchType'] = this.superQueryMatchType
      }
      var param = Object.assign(sqp, this.queryParam, this.isorter ,this.filters);
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
      },
      loadData(arg) {
      if(!this.url.list){
        this.$message.error(this.$t('请设置url.list属性!'))
        return
      }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      var params = this.getQueryParams();//查询条件
      params.mtState = 0;
      console.log(params);
      this.loading = true;
      getAction(this.url.list, params).then((res) => {
        if (res.success) {
          console.log(res.result.records);
          this.meteridlist = res.result.records;
          // this.dataSource = res.result.records;
          this.ipagination.total = res.result.total;
        }
        if(res.code===510){
          this.$message.warning(res.message)
        }
        this.loading = false;
      })
    },
      querygetMeterUserInfoByKeyId(record) {  //换表前缴费
      console.log(record);
        let params = {};
        params.userKeyId =record.id
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.getMeterUserInfoByKeyId, params).then((res) => {
          if(res.success){
            console.log(res);
          this.MeterUserInfoByKey = res.result;
          let MeterUserInfoByKeys ={}
          MeterUserInfoByKeys.meterUserAccountNumAfterChange = res.result.userAccountNum;
          //MeterUserInfoByKeys.meterOldSumFlowAfterChange = res.result.meterTotalUse;
          this.$nextTick(() => {
            this.form.setFieldsValue(pick(MeterUserInfoByKeys,'meterUserAccountNumAfterChange'/*,'meterOldSumFlowAfterChange'*/))
          })
          console.log(this.MeterUserInfoByKey);
          }
        })
      },
      // queryUserCaliberList() {   //表口径请求
      //   let params = {}
      //   params.pageNo = 1;
      //   params.pageSize = listSize;
      //   getAction(this.url.userCaliberList, params).then((res) => {
      //     if(res.success){
      //       this.userCaliberList = res.result.records;
      //       console.log(this.userCaliberList);
      //     }
      //   }) 
      // },
      handleEdit(record) {
        console.log(record);
        this.form.setFieldsValue({
          'meterIdNew' : record.meterId,
        });
        let params = {}
        params.pageNo = 1;
        params.pageSize = 1;
        params.meterId = record.meterId;
        getAction('/jeecg-charge/meter/meterUpData/queryNoAreaPageList', params).then((res) => {
          if(res.success&&res.result.records.length>0){
            let data = res.result.records[0]
            this.form.setFieldsValue({'meterTotalUse': data.meterTotalUse})
            this.form.setFieldsValue({'sysTime': data.sysTime})
          }else{
            this.form.setFieldsValue({'meterTotalUse': null})
            this.form.setFieldsValue({'sysTime': null})
          }
          let meterTotalUse = this.form.getFieldValue('meterTotalUse')
          if(!meterTotalUse){
            this.form.setFieldsValue({'meterStartNum': 0});
            // this.startDisabled = true;
          }else{
            this.form.setFieldsValue({'meterStartNum': ''});
            // this.startDisabled = false;
          }
        })
        this.modal1Visible = false;
      },
      handleCancel(){
        this.modal1Visible = false;
      },
      add () {
        this.edit({});
      },
      edit (record) {
        this.querygetMeterUserInfoByKeyId(record);
        this.form.resetFields();
        this.model = Object.assign({}, record);
        console.log(this.model);
        this.visible = true;
        this.form.setFieldsValue({'whetherSettlementOldTable': 1});
        this.isOldTable = true
      },
      // 查询表编号名称是否重复
      validatePlanName(rule, value, callback){
        if (value==undefined || value=='')  {
          callback(this.$t('请输入表编号!'));
        }else{
          var params ={
          tableName:'meterinfo',
          fieldName:'meter_id',
          fieldVal:value,
          dataId:this.model.id,
          };
          duplicateCheck(params).then((res) => {
            console.log(res);
          if (res.success) {
            callback(this.$t("请在表具信息页面中添加该表编号！"))
          } else {
            callback()
          }
        })
        }
      },
      submitForm () {
        console.log(this.form.getFieldValue('meterUserAccountNumAfterChange'));
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            let meterTotalUse = this.form.getFieldValue('meterTotalUse')
            let meterStartNum = this.form.getFieldValue('meterStartNum')
            console.log(meterTotalUse)
            if(!isUndefinedAndNull(meterTotalUse) &&meterStartNum<meterTotalUse) {
              let that = this
              // that.changeMeter(values)
              this.$confirm({
                title: this.$t('是否确认换表'),
                content: h => <div style="color:red;">{this.$t('新表起始计费读数小于新表最新上报累计用量，{amount}(m³)会进行计费，请确认', { amount: meterTotalUse - meterStartNum })}</div>,
                onOk() {
                  console.log('OK');
                  that.changeMeter(values)
                },
                onCancel() {
                  return
                },
                class: 'test',
              });
            }
            // else if(isUndefinedAndNull(meterTotalUse)){
            //   this.$warning({
            //     title: '信息',
            //     content: `该新表未上报过数据,不能进行换表`,
            //   });
            // }
            else{
              that.changeMeter(values)
            }
          }
        })
      },
      changeMeter(values) {
        let that = this
        that.confirmLoading = true;
        let httpurl = '';
        let method = '';
        if(!this.model.id){
          httpurl+=this.url.add;
          method = 'post';
        }else{
          httpurl+=this.url.edit;
          method = 'put';
        }
        let formData = Object.assign({}, values);
        formData.meterIdOld = this.model.meterId
        formData.userId = this.model.userId
        formData.userKeyId = this.model.id
        formData.meterOldSumFlowAfterChange = this.MeterUserInfoByKey.userCalNum
        formData.meterChangeType = this.model.meterChangeType
        httpAction(httpurl,formData,method).then((res)=>{
          if(res.success&&(res.code === 0||res.code === 200)){
            that.$message.success(res.message || this.$t('换表成功'));
            that.$emit('ok');
          }else{
            that.$message.warning(res.message);
          }
        }).finally(() => {
          that.confirmLoading = false;
        })
      },
      queryUserHouseholdCodeList() {  //用户户型
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.userHouseholdCodeList, params).then((res) => {
          if(res.success){
          this.userHouseholdCodeList = res.result.records;
          }
        })
      },
      // queryUserTypeList() {  //类型编码
      //   let params = {}
      //   params.pageNo = 1;
      //   params.pageSize = listSize;
      //   getAction(this.url.userTypeList, params).then((res) => {
      //     if(res.success){
      //      this.userTypeList = res.result.records;
      //      console.log(this.userTypeList);
      //     }
      //   })
      // },
      queryUserPriceCode() {  //价格编码
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.userPriceCode, params).then((res) => {
          if(res.success){
            this.userPriceCode = res.result.records;
          }
        })
      },
      onRadioChnage(e){
        if(e.target.value == 1){
          this.isOldTable = true;
          let params = {
            meterOldMachineSumFlow: this.form.getFieldValue('meterOldMachineSumFlow'),
            userId: this.model.userId,
            meterIdOld: this.model.meterId,
            userKeyId: this.model.id,
          }
          httpAction(this.url.useOldMachineSumFlow,params,'put').then(res=>{
            if(res.success){
              this.form.setFieldsValue({'meterUserAccountNumAfterChange': res.result});
            }
          })
        }else{
          this.isOldTable = false
        }
      },
      meterOldMachineSumFlowChange(e){
        if(this.form.getFieldValue('whetherSettlementOldTable') == 1){
          this.isOldTable = true;
          let params = {
            meterOldMachineSumFlow: e.target.value,
            userId: this.model.userId,
            meterIdOld: this.model.meterId,
            userKeyId: this.model.id,
          }
          httpAction(this.url.useOldMachineSumFlow,params,'put').then(res=>{
            if(res.success){
              this.form.setFieldsValue({'meterUserAccountNumAfterChange': res.result});
            }
          })
        }else{
          this.isOldTable = false
        }
      },
      onChange(value) {
        // value 是级联选择器的完整路径数组，如 ["1", "2", "3"]
        if (value && value.length > 0) {
          // 获取最后一层的值
          const lastValue = value[value.length - 1]
          // 存储到 formReason 字段
          this.form.setFieldsValue({'meterChangeType': lastValue});
          this.$set(this.model, 'meterChangeType', lastValue)
        }
      },
    }
  }
</script>

<style scoped>
.ant-form-item >>> .ant-select{
  width: 100%;
}
.detail-list >>> .content{
    line-height: normal;
}
</style>